export const TOKEN = "TOKEN";
export const EDIT_TOKEN = "EDIT_TOKEN";
